﻿import { keyCodes } from "@grindex-common/helpers/constants";
import { $elementChild } from "@grindex-common/helpers/elements";

const parameters = {
	page: "page",
	keyword: "keyword",
};

function init($views) {
	if (!$views) {
		return;
	}

	const $module = $views[0];

	const $searchField = $elementChild($module, "search-field");
	const $submit = $elementChild($module, "search-submit");

	$submit.addEventListener("click", search);

	$searchField.addEventListener("keydown", (event) => {
		if (event.keyCode !== keyCodes.enter) {
			return;
		}

		search();
	});

	function search() {
		const keyword = $searchField.value;
		const url = new URL(window.location.href);

		if (!keyword || keyword.length < 3) {
			url.searchParams.delete(parameters.keyword);
		} else {
			url.searchParams.set(parameters.keyword, keyword);
			url.searchParams.delete(parameters.page);
		}

		window.location.href = url.toString();
	}
}

export default {
	view: "search-box",
	init,
};
